module.exports = __webpack_public_path__ + "static/referralrock-77cf9a62dd59aa5a55183fadc6a943b5.png";